/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorStarterPacks.defs'
export { main as default } from './getActorStarterPacks.defs'
